import { FC, memo, useMemo } from 'react';
import { format } from 'echarts';
import { beautifyThePrice, isNotEmpty } from '@lhb/func';
import styles from './index.module.less';
import V2BarChart from '@/common/components/Charts/V2BarChart';

/** 汽车上险量-品牌上险量图表 */
const Component:FC<{
  listData: any[],
  /** 图表高度 */
  height?: number,
}> = ({ listData, height }) => {

  /* state */
  const xAxisData = useMemo(() => listData.map(item => item.label), [listData]);
  const seriesData = useMemo(() => {
    return [{
      // name: '销售额',
      data: listData.map(item => item.value),
    }];
  }, [listData]);
  const chartHeight = isNotEmpty(height) ? height : listData.length * 24 + 17 + 20 + 16 + 36; // + X轴（17） + 间距（20） + 标题（16） + 底部（36）

  /* hooks */

  /* methods */

  return (<V2BarChart
    direction='horizontal'
    xAxisData={xAxisData}
    seriesData={seriesData}
    height={chartHeight}
    wrapperClassName={styles.carListChart}
    border={false}
    config={{
      legend: { show: false },
      grid: { top: 16, left: 70, bottom: 36, right: 26 },
      xAxis: {
        axisLabel: {
          width: 60,
          overflow: 'truncate', // 超出部分省略号，必须配上 width
        }
      },
      yAxis: {
        splitNumber: 4,
      },
      tooltip: {
        backgroundColor: '#fff',
        textStyle: {
          color: '#666666',
          fontWeight: 'normal',
          fontSize: 12,
          fontFamily: 'PingFangSC-Regular, PingFang SC',
        },
        // 处理悬浮展示文案
        formatter: params => {
          const axisValueLabel = params[0]?.axisValueLabel || '-';
          const dataStr = (Array.isArray(params) ? params : []).map((item) => {
            const descStr = '';
            // const seriesName = item.data?.label || item.seriesName;
            const value = isNotEmpty(item.value) ? `${format.encodeHTML(beautifyThePrice(item.value, ',', 'auto'))}${item.unit || ''}${descStr}` : '-';
            // 注：`echarts.format.encodeHTML` 是个工具函数，把特殊字符，（'&'、'<'、'>'、'"'、"'"）转换成他们对应的 HTML entities，这只是个例子，任何 HTML 转义工具函数都可使用。
            return `<div style='display: flex;justify-content: space-between;align-items: center;gap: 20px;'>
              <span style='color: #222;'>${value}</span>
            </div>`;
          }).join('');
          return `<div style='margin-bottom: 4px;'>${axisValueLabel}</div>` + dataStr;
        }
      },
    }}
  />);
};

export default memo(Component);
